import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { UsersIcon, SparklesIcon, MessageSquareIcon, RocketIcon, MenuIcon, XIcon } from 'lucide-react';
const CommunityNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    name: 'Product',
    href: '/#product'
  }, {
    name: 'Components',
    href: '/#components'
  }, {
    name: 'Platform',
    href: '/#platform'
  }, {
    name: 'Security',
    href: '/#security'
  }, {
    name: 'Community',
    href: '/community'
  }, {
    name: 'Pricing',
    href: '/#pricing'
  }];
  return <header className="w-full bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100" data-id="element-1219">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-1220">
        <div className="flex items-center gap-2" data-id="element-1221">
          <Link to="/" className="flex items-center group" data-id="element-1222">
            <img src="https://cdn.magicpatterns.com/uploads/fMJnv7yQ9EawQ6b54Tnvxq/FWLogo.png" alt="FluidWeb Logo" className="h-8 transition-opacity group-hover:opacity-80" data-id="element-1223" />
          </Link>
        </div>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-1224">
          {navItems.map((item, index) => item.href.startsWith('/#') ? <a key={index} href={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1225">
                {item.name}
              </a> : <Link key={index} to={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1226">
                {item.name}
              </Link>)}

          <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap" data-id="element-1227">
            Get a demo
          </a>
        </nav>

        <button className="md:hidden text-gray-700 p-2" onClick={() => setIsOpen(!isOpen)} data-id="element-1228">
          {isOpen ? <XIcon size={24} data-id="element-1229" /> : <MenuIcon size={24} data-id="element-1230" />}
        </button>
      </div>

      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 absolute w-full left-0 top-full shadow-xl" data-id="element-1231">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-1232">
            {navItems.map((item, index) => item.href.startsWith('/#') ? <a key={index} href={item.href} className="text-gray-700 py-2 hover:text-orange-500 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-1233">
                  {item.name}
                </a> : <Link key={index} to={item.href} className="text-gray-700 py-2 hover:text-orange-500 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-1234">
                  {item.name}
                </Link>)}
            <div className="border-t border-gray-100 pt-4" data-id="element-1235">
              <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-4 py-3 rounded-lg hover:bg-gray-800 transition-colors text-center font-medium block" data-id="element-1236">
                Get a demo
              </a>
            </div>
          </div>
        </div>}
    </header>;
};
const Community = () => {
  return <div className="w-full min-h-screen font-sans bg-white text-gray-900" data-id="element-1237">
      <CommunityNavbar data-id="element-1238" />

      <main className="container mx-auto px-4 py-16 md:py-24" data-id="element-1239">
        <div className="max-w-5xl mx-auto" data-id="element-1240">
          {/* Header */}
          <div className="text-center mb-16" data-id="element-1241">
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-200 rounded-full px-4 py-2 mb-6" data-id="element-1242">
              <SparklesIcon className="w-4 h-4 text-orange-500" data-id="element-1243" />
              <span className="text-sm font-semibold text-orange-900" data-id="element-1244">
                Early Access
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-1245">
              Join FluidWeb Community
            </h1>

            <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-1246">
              Connect with developers, product managers, and designers building
              the future of agentic interfaces
            </p>
          </div>

          {/* Benefits */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-1247">
            <div className="text-center" data-id="element-1248">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-1249">
                <UsersIcon className="w-6 h-6 text-orange-600" data-id="element-1250" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-1251">Early Access</h3>
              <p className="text-sm text-gray-600" data-id="element-1252">
                Get first access to new features and beta releases
              </p>
            </div>

            <div className="text-center" data-id="element-1253">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-1254">
                <MessageSquareIcon className="w-6 h-6 text-orange-600" data-id="element-1255" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-1256">Direct Influence</h3>
              <p className="text-sm text-gray-600" data-id="element-1257">
                Shape the product roadmap with your feedback
              </p>
            </div>

            <div className="text-center" data-id="element-1258">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-1259">
                <RocketIcon className="w-6 h-6 text-orange-600" data-id="element-1260" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-1261">Learn & Share</h3>
              <p className="text-sm text-gray-600" data-id="element-1262">
                Exchange patterns and best practices with peers
              </p>
            </div>
          </div>

          {/* Form Embed - Fixed Mobile Overflow */}
          <div className="bg-gray-50 rounded-2xl border border-gray-200 p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden" data-id="element-1263">
            <div id="fluidform-embed-apply-to-join-fluidweb-community" style={{
            position: 'relative',
            width: '100%'
          }} data-id="element-1264">
              <div id="fluidform-embed-basic" style={{
              position: 'relative',
              width: '100%'
            }} data-id="element-1265">
                <script src="https://app.fluid-form.ai/fluid-navigate.js" data-id="element-1266"></script>
                <iframe id="fluidform-iframe-apply-to-join-fluidweb-community" src="https://app.fluid-form.ai/ff/org_39ojnmw3A3YsoOMUVZghwHqA808/apply-to-join-fluidweb-community?sig=org_39ojnmw3A3YsoOMUVZghwHqA808-apply-to-join-fluidweb-community-d6d29f287e5d6d50&mode=headless&chatPath=chat-router" width="100%" title="Form basic" style={{
                border: 0,
                background: 'transparent',
                width: '100%',
                minHeight: '500px',
                overflow: 'hidden',
                display: 'block'
              }} frameBorder="0" scrolling="no" allowTransparency={true} data-id="element-1267" />
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-1268" />
    </div>;
};
export default Community;